import React from 'react';
import { Heart, Users, Zap } from 'lucide-react';

const Manifesto = () => {
  return (
    <section className="py-20 bg-warmCream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-black text-richBrown mb-6 tracking-tight">
            Our Manifesto
          </h2>
          <div className="w-24 h-1 bg-goldAccent mx-auto mb-8"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-goldAccent rounded-full flex items-center justify-center">
                <Heart className="w-6 h-6 text-richBrown" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-richBrown mb-2 tracking-wide">Embrace Your Melanin</h3>
                <p className="text-warmBrown leading-relaxed">
                  We celebrate the beauty of brown skin in all its shades. Your melanin is magic, not a flaw to fix.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-goldAccent rounded-full flex items-center justify-center">
                <Zap className="w-6 h-6 text-richBrown" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-richBrown mb-2 tracking-wide">Reject False Standards</h3>
                <p className="text-warmBrown leading-relaxed">
                  We're done with Eurocentric beauty norms. Real beauty comes in brown, and we're here to prove it.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-goldAccent rounded-full flex items-center justify-center">
                <Users className="w-6 h-6 text-richBrown" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-richBrown mb-2 tracking-wide">Own Your Presence</h3>
                <p className="text-warmBrown leading-relaxed">
                  Through minimalist streetwear that speaks volumes, we help you own every room you enter.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square bg-gradient-to-br from-warmBrown to-deepBrown rounded-lg overflow-hidden relative">
              <img 
                src="https://customer-assets.emergentagent.com/job_melanin-standard/artifacts/ai1zrupa_IMG_0502.jpeg"
                alt="Cultural pride and beauty"
                className="w-full h-full object-cover opacity-90"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-richBrown/40 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-warmCream font-bold text-lg tracking-wide">
                  "Brown isn't a trend. It's the standard."
                </p>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-8 h-8 bg-goldAccent rounded-full"></div>
            <div className="absolute -bottom-4 -left-4 w-6 h-6 border-2 border-goldAccent rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;